import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowRight } from "lucide-react";
import logoBettr from "../../assets/logo-bettr.png";

const EMAIL = "mailto:info@bettrmobility.com";

const LINKS = [
  { label: "FLEET", href: "#journeys" },
  { label: "SERVICES", href: "#services" },
  { label: "ABOUT US", href: "#standard" },
  { label: "CONTACT", href: EMAIL },
];

const Logo = () => (
  <a href="#top" data-testid="nav-logo" className="flex items-center select-none">
    <img
      src={logoBettr}
      alt="Bettr Mobility"
      className="h-8 sm:h-10 w-auto object-contain"
    />
  </a>
);

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 transition-colors duration-500"
      style={{
        backgroundColor: scrolled ? "#09090A" : "rgba(15,16,18,0.35)",
        borderBottom: scrolled
          ? "1px solid rgba(201,163,91,0.18)"
          : "1px solid rgba(238,236,231,0.06)",
        backdropFilter: "blur(8px)",
      }}
    >
      <div className="container-bettr flex items-center justify-between h-[72px]">
        <Logo />

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-sans text-[12px] tracking-[0.12em] text-ivory/80 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href={EMAIL} data-testid="nav-book-btn" className="btn-gold">
            BOOK A JOURNEY <ArrowRight size={15} className="arrow" strokeWidth={1.6} />
          </a>
        </div>

        <button
          data-testid="nav-hamburger"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-ivory p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-blackk border-t border-gold/15"
          >
            <div className="container-bettr py-8 flex flex-col gap-6">
              {LINKS.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-sans text-sm tracking-[0.14em] text-ivory/85 hover:text-gold transition-colors"
                >
                  {l.label}
                </a>
              ))}
              <a href={EMAIL} onClick={() => setOpen(false)} className="btn-gold w-full justify-center mt-2">
                BOOK A JOURNEY <ArrowRight size={15} className="arrow" strokeWidth={1.6} />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
